import mapValues from 'lodash/mapValues';
import { css, ThemedCssFunction } from 'styled-components';
import { defaults } from './defaults';

type Breakpoints = typeof defaults.breakpoints;
type Breakpoint = keyof Breakpoints;
type Media = { [K in keyof Breakpoints]: ThemedCssFunction<any> };

export const media: Media = mapValues<Breakpoints, ThemedCssFunction<any>>(
  defaults.breakpoints,
  (_: number, key: string) => (
    strings: TemplateStringsArray,
    ...args: any
  ) => css`
    @media (min-width: ${defaults.breakpoints[key as Breakpoint]}px) {
      ${css(strings, ...args)};
    }
  `
);

export const maxWidth: Media = mapValues<Breakpoints, ThemedCssFunction<any>>(
  defaults.breakpoints,
  (_: number, key: string) => (
    strings: TemplateStringsArray,
    ...args: any
  ) => css`
    @media (max-width: ${defaults.breakpoints[key as Breakpoint] - 1}px) {
      ${css(strings, ...args)};
    }
  `
);

export const font = (size = 1.8, line = 2.4, weight = '300') => css`
  font-size: ${defaults.fontSize * size}rem;
  line-height: ${defaults.fontSize * line}rem;
  font-weight: ${weight};
`;

export const clearfix = () => css`
  &:after {
    content: '';
    display: table;
    clear: both;
  }
`;
